module.exports = __webpack_public_path__ + "img/4_0.080fec01.png";